<div class="layoutBlock">
    <div class="columnHalf">
        <p-panel
            header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData' | hisUi}}"
            [toggleable]="false">
            <his-plam>
                <p-autoComplete #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.country"
                    styleClass="autocompleteWidth100" field="text" [(ngModel)]="travelData.countrySelected"
                    hisEagerDataSource="api/v1/rm/erp/person/value/erpcountry" [forceSelection]="true"
                    (ngModelChange)="onModelChange($event)">
                </p-autoComplete>
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.destination"
                    class="inputWidth100" [(ngModel)]="travelData.destination"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.purpose"
                    class="inputWidth100" [(ngModel)]="travelData.travelManagementPurpose"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.destinationfreetext"
                    class="inputWidth100" [(ngModel)]="travelData.destinationFreetext"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>
        </p-panel>

        <p-panel
            header=" {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.additionalInformation' | hisUi}}"
            [toggleable]="false">

            <his-plam>
                <p-autoComplete #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.billingbasis"
                    styleClass="autocompleteWidth100" field="text" [(ngModel)]="travelData.billingbasisSelected"
                    hisEagerDataSource="api/v1/rm/erp/travelmanagement/values/erpbillingbasis" [forceSelection]="true"
                    (ngModelChange)="onModelChange($event)">
                </p-autoComplete>
            </his-plam>
        </p-panel>
    </div>

    <div class="columnHalf">
        <p-panel
            header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.travelTimes' | hisUi}}"
            [toggleable]="false">
            <his-plam>
                <p-autoComplete #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.arrival"
                    styleClass="autocompleteWidth100" field="text" [(ngModel)]="travelData.arrivalSelected"
                    hisEagerDataSource="api/v1/rm/erp/travelmanagement/values/erparrival" [forceSelection]="true"
                    (ngModelChange)="onModelChange($event)">
                </p-autoComplete>
            </his-plam>

            <his-plam>
                <p-calendar #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.tripBeginDate"
                    [(ngModel)]="travelData.tripBeginDate" [dateFormat]="dateTimeFormat" [showTime]="true"
                    styleClass="calendarWidth100" [monthNavigator]="true" [yearNavigator]="true"
                    [placeholder]="datePlaceholderFormat" (ngModelChange)="onModelChange($event)">
                </p-calendar>
            </his-plam>

            <div class="clearAndSpace"></div>

            <his-plam>
                <p-autoComplete #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.returnTrip"
                    styleClass="autocompleteWidth100" field="text" [(ngModel)]="travelData.returnTripSelected"
                    hisEagerDataSource="api/v1/rm/erp/travelmanagement/values/erpreturntrip" [forceSelection]="true"
                    (ngModelChange)="onModelChange($event)">
                </p-autoComplete>
            </his-plam>

            <his-plam>
                <p-calendar #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.tripEndDate"
                    [(ngModel)]="travelData.tripEndDate" [dateFormat]="dateTimeFormat" [showTime]="true"
                    styleClass="calendarWidth100" [monthNavigator]="true" [yearNavigator]="true"
                    [placeholder]="datePlaceholderFormat" (ngModelChange)="onModelChange($event)">
                </p-calendar>
            </his-plam>

            <div class="clearAndSpace"></div>

            <his-plam>
                <p-calendar #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.businessBeginDate"
                    [(ngModel)]="travelData.businessBeginDate" [dateFormat]="dateTimeFormat" [showTime]="true"
                    styleClass="calendarWidth100" [monthNavigator]="true" [yearNavigator]="true"
                    [placeholder]="datePlaceholderFormat" (ngModelChange)="onModelChange($event)">
                </p-calendar>
            </his-plam>

            <his-plam>
                <p-calendar #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.businessEndDate"
                    [(ngModel)]="travelData.businessEndDate" [dateFormat]="dateTimeFormat" [showTime]="true"
                    styleClass="calendarWidth100" [monthNavigator]="true" [yearNavigator]="true"
                    [placeholder]="datePlaceholderFormat" (ngModelChange)="onModelChange($event)">
                </p-calendar>
            </his-plam>
        </p-panel>
    </div>
</div>